/* ===========================================================
   customize-ai-launcher.js
   -----------------------------------------------------------
   Rewrites Microsoft Brand Agent strings to match Makartt's
   "Makie" persona. Covers launcher pill text, ARIA labels,
   and the chat input placeholder.

   Replacement rules (exact-match):
     "Shop with AI"              → "Ask Makie"
       (launcher pill text on home/cart + aria-label everywhere)
     "Browse this collection?"   → "Ask Makie about this collection"
       (launcher pill text on collection pages)
     "Message MakarttPro AI"     → "Message Makie"
       (chat input placeholder)

   Intentionally left UNTOUCHED (forward-compatible by design):
     - "Save $X.XX on this product!" — dynamic savings copy on PDPs
       is worth more than brand consistency.
     - "Welcome to MakarttPro" — accurate branding line in chat.
     - Any other Microsoft string we haven't explicitly mapped.

   How it works:
     - The agent lives inside <div id="ads-agent-host"> with an
       OPEN shadow root, so we can reach in via JS.
     - Microsoft loads asynchronously; we poll for the host
       (up to 30s), then attach a MutationObserver to re-apply
       after every re-render (open chat, navigate, etc.).
     - Sweep covers text nodes + placeholder/aria-label attrs.

   Reverse: delete this file and its <script> include in
   layout/theme.liquid.
   =========================================================== */
(function () {
  'use strict';

  var REPLACEMENTS = {
    'Shop with AI': 'Ask Makie',
    'Browse this collection?': 'Ask Makie about this collection',
    'Message MakarttPro AI': 'Message Makie'
  };

  function rewriteText(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return false;
    var current = (node.nodeValue || '').trim();
    var target = REPLACEMENTS[current];
    if (target && current !== target) {
      node.nodeValue = target;
      return true;
    }
    return false;
  }

  function rewriteAttribute(el, attrName) {
    var current = el.getAttribute(attrName);
    if (!current) return false;
    var target = REPLACEMENTS[current.trim()];
    if (target && current !== target) {
      el.setAttribute(attrName, target);
      return true;
    }
    return false;
  }

  function sweep(root) {
    if (!root) return 0;
    var changed = 0;
    // Text nodes
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (rewriteText(node)) changed++;
    }
    // Attribute replacements: chat input placeholder
    root.querySelectorAll('[placeholder]').forEach(function (el) {
      if (rewriteAttribute(el, 'placeholder')) changed++;
    });
    // Attribute replacements: launcher + chat aria-labels
    root.querySelectorAll('[aria-label]').forEach(function (el) {
      if (rewriteAttribute(el, 'aria-label')) changed++;
    });
    return changed;
  }

  var observer = null;
  var pollTimer = null;

  function attachToHost() {
    var host = document.querySelector('#ads-agent-host');
    if (!host || !host.shadowRoot) return false;

    sweep(host.shadowRoot);

    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      sweep(host.shadowRoot);
    });
    observer.observe(host.shadowRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['placeholder', 'aria-label']
    });

    return true;
  }

  function init() {
    if (attachToHost()) return;

    // Microsoft loads the agent asynchronously — poll for it.
    var attempts = 0;
    var MAX_ATTEMPTS = 150; // 30s at 200ms
    pollTimer = setInterval(function () {
      attempts++;
      if (attachToHost() || attempts >= MAX_ATTEMPTS) {
        clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
